import { Box, styled, Divider } from '@mui/material'
import IconCommon from 'assets/icon/IconCommon'
import { colors } from 'constants/theme'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { dateMonthToView, timeToView } from 'utils/date.utils'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import moment from 'moment'


type pdfThermalEN = {
    branchInfo: any
    appointment: any
    user: any

}

const PDFThermalEN = (props: pdfThermalEN) => {
    const { branchInfo, appointment, user } = props
    const { t } = useTranslation()

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '16px',
                    paddingBottom: '16px',
                    img: { height: 100, width: 'auto' }
                }}
            >
                {branchInfo?.branchLogo && (
                    <img src={branchInfo.branchLogo} alt="logo" />
                )}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    marginLeft: '10px',
                    marginRight: '10px'
                }}
            >
                <Box mb={1}>
                    <Box fontSize={16} fontWeight="bold" color="black">
                        {branchInfo?.clinicNameEn ?? ''}
                    </Box>
                    <Box fontSize={12} color="black">
                        {branchInfo?.branchNameEn ?? ''}
                    </Box>
                </Box>
                <Box>
                    <Box fontSize={12} color="black">
                        {branchInfo?.branchFullAddressEn ?? ''}
                    </Box>
                    <Box fontSize={12} color="black">
                        {`${t('APPOINTMENT.PDF.WEB_EN')}: ${branchInfo?.branchWebsite ?? ''
                            } / ${t('APPOINTMENT.PDF.EMAIL_EN')}: ${branchInfo?.branchEmail ?? ''
                            }`}
                    </Box>
                    <Box fontSize={12} color="black">
                        {`${t('APPOINTMENT.PDF.TEL_EN')}: ${branchInfo?.branchPhone1 ?? ''
                            } ${t('APPOINTMENT.PDF.LINE_EN')}@: ${branchInfo?.branchLine ?? ''
                            }`}
                    </Box>
                </Box>
            </Box>
            <Box marginLeft='10px' marginRight='10px'>
                <Box whiteSpace="nowrap" fontSize={16} paddingY='10px' fontWeight="bold" textAlign="center" justifyContent="center" color="black">
                    {t('APPOINTMENT.PDF.APPOINTMENT_CARD_EN')}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box component="span" fontWeight="bold">
                        {t('APPOINTMENT.PDF.APPOINTMENT_NUMBER_EN')}:
                    </Box>{' '}
                    {appointment?.appointmentNumber ?? ''}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.PATIENT_CN_NUMBER_EN')}:{' '}
                    </Box>
                    {appointment?.cnNumber ?? ''}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.PATIENT_NAME_EN')}:{' '}
                    </Box>
                    {`${appointment?.prefixNameEn ?? ''} ${appointment?.firstnameEn || appointment?.firstname
                        } ${appointment?.lastnameEn || appointment?.lastname}`}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.DATE_EN')}:{' '}
                    </Box>
                    {appointment?.date
                        ? dateMonthToView(appointment.date, true, 'en')
                        : ''}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.TIME_EN')}:{' '}
                    </Box>
                    {`${appointment?.timeStart?.substring(0, 5)} ${t('APPOINTMENT.PDF.TIME_UNIT_EN')
                        }`}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.DOCTOR_NAME_EN')}:{' '}
                    </Box>
                    {`${appointment?.doctorFirstnameEn ?? ''} ${appointment?.doctorLastnameEn ?? ''}`}
                </Box>
                <Box whiteSpace="nowrap" fontSize={12} color="black">
                    <Box
                        component="span"
                        sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                    >
                        {t('APPOINTMENT.PDF.TREATMENT_EN')}:
                    </Box>
                </Box>
                <Box marginBottom="10px">
                    {appointment?.appointmentOperatives?.map((item: any, idx: any) => (
                        <Box
                            key={idx}
                            sx={{ fontSize: '12px', color: 'black' }}
                        >
                            <FiberManualRecordIcon
                                sx={{ width: 5, height: 5, mr: 1, ml: 1, color: 'black' }}
                            />
                            {item?.operativeNameEn || item?.operativeTypeNameEn}
                        </Box>
                    ))}
                </Box>
                <Divider
                    sx={{
                        margin: '0 !important',
                        borderColor: '#b8b8b8 !important',
                        height: '1px !important'
                    }}
                />
                <Box
                    display="flex"
                    marginBottom="8px"
                    marginTop="8px"
                    flexDirection="column"
                >
                    <Box whiteSpace="nowrap" fontSize={12} color="black">
                        <Box
                            component="span"
                            sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                        >
                            {t('APPOINTMENT.PDF.AUTH_EN')}:{' '}
                        </Box>
                        {user?.fullnameEn ?? ''}
                    </Box>

                    <Box whiteSpace="nowrap" fontSize={12} color="black">
                        <Box
                            component="span"
                            sx={{ fontWeight: 'bold', fontSize: '12px', color: 'black' }}
                        >
                            {t('APPOINTMENT.PDF.AUTH_DATE_EN')}:{' '}
                        </Box>
                        {`${dateMonthToView(moment(), true, 'en')} (${timeToView()})`}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default PDFThermalEN